var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$store.state.screen ? 'screen' : '',attrs:{"id":"app"}},[_c('topBar'),_vm._v(" "),(_vm.$route.meta.keepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.key})],1):_c('router-view'),_vm._v(" "),_c('footerModule')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46266cad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 